export default "__VITE_ASSET__BUlT4oic__"